module.exports = "/src/views/player/help/images/fib2.jpg";